import { Timestamp } from "firebase/firestore";
import { StartupStatus } from "./StartupStatus";

export const ProjectCollection = "projects";

export function mapDocToProject(id: string, data: any): Project {
  return {
    id,
    creatorUserId: data.creatorUserId,
    name: data.name,
    description: data.description,
    createdAt: data.createdAt,
    updatedAt: data.updatedAt,
    startupStatus: data.startupStatus || [],
    sectors: data.sectors || [],
    // Stripe Connect
    stripeConnectCode: data.stripeConnectCode,
    stripeConnectScope: data.stripeConnectScope,
    stripeConnectTimestamp: data.stripeConnectTimestamp,
  };
}

export interface Project {
  id: string;
  name: string;
  description: string;
  creatorUserId: string;
  createdAt: Timestamp;
  updatedAt: Timestamp;
  startupStatus?: StartupStatus[];
  sectors?: string[];
  // Stripe Connect
  stripeConnectCode?: string;
  stripeConnectScope?: string;
  stripeConnectTimestamp?: Timestamp;
}
